export default __webpack_public_path__ + "static/ElenaZh-7a868511710712261221b087952d2a5f.jpg";